import { render, staticRenderFns } from "./Inversiones.vue?vue&type=template&id=0e3b1dcf&scoped=true"
import script from "./Inversiones.vue?vue&type=script&lang=js"
export * from "./Inversiones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3b1dcf",
  null
  
)

export default component.exports